import React from "react";
import cx from "classnames";
import LoadingBoundary from "@ui/LoadingBoundary";
import SidePanelLayout from "@ui/SidePanel/Layout";
import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import { styled } from "@linaria/react";
import { useSettings } from "../../../api/useSettings";

interface P {
  quantities: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
}

const CompactSidePanelLayout = styled(SidePanelLayout)`
  padding: 24px 48px;
`;
const ExplorationSidePanelLayout = styled(SidePanelLayout)`
  padding: 24px 0;
  padding: 24px 0 !important;
`;

const QuantityLayout = ({ quantities, children, className, compact }: P) => {
  const settings = useSettings();
  const LayoutComponent = compact
    ? CompactSidePanelLayout
    : settings.NEW_NAVIGATION_ENABLED
      ? ExplorationSidePanelLayout
      : SidePanelLayout;

  return (
    <LayoutComponent className={cx(quantityLayout, className)}>
      <LoadingBoundary>
        <div className={quantityLayoutAside}>{quantities}</div>
      </LoadingBoundary>
      <div className={quantityLayoutMain}>
        <div>{children}</div>
      </div>
    </LayoutComponent>
  );
};

export default React.memo(QuantityLayout);

const quantityLayoutMain = css`
  > div:first-child:last-child {
    height: 100%;
  }
`;

const quantityLayout = css`
  flex-direction: row;
  gap: ${spacings.l};

  &,
  & > div:last-child,
  .${quantityLayoutMain} {
    flex: 1;
  }
`;

const quantityLayoutAside = css`
  display: flex;
  width: max(280px, min(25vw, 400px));
`;
